require('./header.scss');

export default function HeaderComponent() {
  return {
    controller: HeaderController,
    template: require('./header.html')
  };
}

// @ngInject
class HeaderController {

  constructor($ngRedux, $scope) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
  }

  $onInit() {
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working
        };
      }
    )(this); // Permet d'avoir les propriétés de l'objet retourné dans this (ici working)

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }
}



// WEBPACK FOOTER //
// ./src/modules/base/components/header/header.component.js